/* eslint-disable no-unused-vars */
/* eslint-disable no-empty */
import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { FormControlLabel } from "@material-ui/core";
import Checkbox from "@material-ui/core/Checkbox";
import WBlogo from "../../../../assets/icons/WBlogo.svg";
import WBlogoBlue from "../../../../assets/icons/blueWBlogo.svg";
import EyeIcon from "../../../../assets/icons/eye.svg";
import CustomInput from "../../../../components/CustomInput";
import CustomButton from "../../../../components/CustomButton";
import {
  loginAction,
  socialMediaRegister,
  resendOTPAction,
  activateUserAction,
} from "../../../../redux/actions/authActions";
import { getJobListAction } from "../../../../redux/actions/jobActions";
import { AUTH_LOADING, STOP_AUTH_LOADING } from "../../../../redux/actionTypes";
import { isValidEmail, shouldRedirectToStoredPath } from "../../../../utils/helpers";
import AuthWrapper from "../AuthWrapper";
import { useHistory } from "react-router-dom";
import "./index.css";
import GoogleLogin from "react-google-login";

const Signin = () => {
  const [state, setState] = useState({
    email: "",
    password: "",
    account_type: "referral",
    rememberMe: !!localStorage.rememberMe,
  });

  const sheetRef = useRef();
  const googleLoginClickHandler = useRef(null);

  const [showsocial, setShowSocial] = useState(true);
  const history = useHistory();

  const [showActivationForm, setShowActivationForm] = useState(false);
  const [activationCode, setActivationCode] = useState("");
  const [activationEmail, setActivationEmail] = useState("");
  const [activationError, setActivationError] = useState("");
  const [showBusinessMessage, setShowBusinessMessage] = useState(false);
  const [validationError, setValidationError] = useState("");

  const { loading } = useSelector((store) => store.auth);
  const dispatch = useDispatch();

  useEffect(() => {
    Promise.resolve(getJobListAction(dispatch));
  }, [dispatch]);

  const handleChange = ({ target: { id, value, checked } }) => {
    // Clear validation error when user starts typing
    if (validationError) {
      setValidationError("");
    }
    
    if (id === "rememberMe") {
      if (checked) {
        localStorage.setItem("rememberMe", "true");
      } else {
        localStorage.removeItem("rememberMe");
      }
      setState((prevState) => ({ ...prevState, [id]: checked }));
    } else {
      setState((prevState) => ({ ...prevState, [id]: value }));
    }
  };


  const handleSubmit = async (event) => {
    event.preventDefault();
    
    // Validate email and password before submitting
    if (!state.email.trim()) {
      setValidationError("Please enter your email address");
      return;
    }
    
    if (!isValidEmail(state.email.trim())) {
      setValidationError("Please enter a valid email address");
      return;
    }
    
    if (!state.password) {
      setValidationError("Please enter your password");
      return;
    }
    
    // Clear any previous validation errors
    setValidationError("");
    
    dispatch({ type: AUTH_LOADING });

    try {
      const response = await loginAction(state, dispatch);

      if (response && response.type === "ERROR") {
        const message = response.payload || "";

        if (
          message.toLowerCase().includes("not activated") ||
          message.toLowerCase().includes("account not activated")
        ) {
          setActivationEmail(state.email);
          setShowActivationForm(true);
          setActivationError(
            "Your account is not activated. Please enter your activation code or request a new one."
          );
          dispatch({ type: STOP_AUTH_LOADING });
          return;
        }
      }

      localStorage.setItem("accountType", "referral");

      const pageToVisit = sessionStorage.getItem("pageToVisit");
      const accountType = localStorage.getItem("accountType");
      if (pageToVisit) {
        sessionStorage.removeItem("pageToVisit");
        const pageToVisitInfo = JSON.parse(pageToVisit);
        if (shouldRedirectToStoredPath(pageToVisitInfo, accountType)) {
          history.push(pageToVisitInfo.path);
        }
      }
    } catch (error) {
    } finally {
      dispatch({ type: STOP_AUTH_LOADING });
    }
  };

  const handleActivate = async (e) => {
    e.preventDefault();
    setActivationError("");

    if (!activationCode.trim()) {
      setActivationError("Please enter activation code");
      return;
    }

    dispatch({ type: AUTH_LOADING });

    try {
      const response = await activateUserAction(dispatch, activationCode);

      if (response && response.type === "ERROR") {
        const msg =
          response.payload || "Failed to activate account. Please try again.";
        setActivationError(msg);
        dispatch({ type: STOP_AUTH_LOADING });
        return;
      }

      localStorage.setItem("accountType", "referral");

      const pageToVisit = sessionStorage.getItem("pageToVisit");
      const accountType = localStorage.getItem("accountType");
      if (pageToVisit) {
        sessionStorage.removeItem("pageToVisit");
        const pageToVisitInfo = JSON.parse(pageToVisit);
        if (shouldRedirectToStoredPath(pageToVisitInfo, accountType)) {
          history.push(pageToVisitInfo.path);
        }
      }
    } catch (error) {
      const msg =
        error?.message || "Failed to activate account. Please try again.";
      setActivationError(msg);
    } finally {
      dispatch({ type: STOP_AUTH_LOADING });
    }
  };

  const handleResendOTP = async () => {
    if (!activationEmail) {
      setActivationError("Email not found. Please try logging in again.");
      return;
    }

    dispatch({ type: AUTH_LOADING });
    try {
      await resendOTPAction({ email: activationEmail }, dispatch);
      setActivationError("New activation code has been sent to your email.");
    } catch (error) {
      setActivationError("Failed to resend activation code. Please try again.");
    } finally {
      dispatch({ type: STOP_AUTH_LOADING });
    }
  };

  const handleBackToLogin = () => {
    setShowActivationForm(false);
    setActivationCode("");
    setActivationError("");
  };

  const responseGoogle = (response) => {
    if (response.error) return;
    const { accessToken, profileObj } = response;

    const payload = {};
    payload["email"] = profileObj?.email;
    payload["platform_uid"] = profileObj?.googleId;
    payload["platform"] = "google";
    payload["first_name"] = profileObj?.givenName;
    payload["last_name"] = profileObj?.familyName;
    payload["fcm_token"] = accessToken;
    payload["invited_by_code"] = "";

    dispatch({ type: AUTH_LOADING });
    Promise.resolve(socialMediaRegister(payload, dispatch)).finally(() => {
      try {
        const pageToVisit = sessionStorage.getItem("pageToVisit");
        const accountType = localStorage.getItem("accountType");
        if (pageToVisit) {
          sessionStorage.removeItem("pageToVisit");
          const pageToVisitInfo = JSON.parse(pageToVisit);
          if (shouldRedirectToStoredPath(pageToVisitInfo, accountType)) {
            history.push(pageToVisitInfo.path);
          }
        }
      } catch (error) {}
      dispatch({ type: STOP_AUTH_LOADING });
    });
  };

  const switchToBusiness = () => {
    setShowBusinessMessage(true);
  };

  return (
    <>
      <AuthWrapper>
        <div className="form-container d-flex justify-content-center">
          {showActivationForm ? (
            <div className="auth-form ml-md-4 my-5">
              <h4 className="text-center mt-4">Enter Activation Code</h4>
              <p className="text-center">
                <small>
                  Check your email inbox/spam for the activation code
                </small>
              </p>

              {activationError && (
                <p
                  className={`text-center ${
                    activationError.includes("sent to your email")
                      ? "text-success"
                      : "text-danger"
                  }`}
                >
                  {activationError}
                </p>
              )}

              <form onSubmit={handleActivate} className="pt-2 pb-3">
                <CustomInput
                  onChange={(e) => setActivationCode(e.target.value)}
                  type="text"
                  label="Activation Code"
                  id="activation_code"
                  value={activationCode}
                  placeholder="Enter the code sent to your email"
                />

                <CustomButton
                  type="submit"
                  backgroundColor="#3A6ED4"
                  color="#fff"
                  text="Activate Account"
                  loading={loading}
                  additionalClass="my-3"
                />

                <div className="d-flex justify-content-center">
                  <CustomButton
                    type="button"
                    color="#3A6ED4"
                    text="Resend Code"
                    additionalClass="no-border"
                    handleClick={handleResendOTP}
                    disabled={loading}
                  />
                </div>

                <div className="d-flex justify-content-center mt-3">
                  <button
                    type="button"
                    className="btn btn-link"
                    onClick={handleBackToLogin}
                    style={{ color: "#666" }}
                  >
                    ← Back to Login
                  </button>
                </div>
              </form>
            </div>
          ) : showBusinessMessage ? (
            <div className="auth-form ml-md-4 my-5">
              <div className="business-coming-soon">
                <div className="business-header pt-5">
                  {/* <img
                    src={WBlogoBlue}
                    alt="Workbrook Business"
                    className="business-logo"
                  /> */}
                  <h3 className="business-title">
                    workbrook Business Solutions
                  </h3>
                </div>

                <div className="business-content">
                  <p className="business-tagline">
                    Partner with workbrook to power your hiring
                  </p>

                  <p className="business-description">
                    Looking to register your business and unlock the full
                    potential of workbrook Business Solutions? We are here to
                    help you streamline recruitment, engage talent, and grow
                    with confidence.
                  </p>

                  <div className="business-cta">
                    <h4 className="cta-title">
                      Reach out to our Business Team
                    </h4>
                    <p className="cta-description">
                      For registration and tailored support, please contact us
                      directly at:
                    </p>
                    <a
                      href="mailto:business@workbrook.com"
                      className="business-email"
                    >
                      business@workbrook.com
                    </a>
                    <p className="cta-footer">
                      Our team will walk you through the setup process, answer
                      your questions, and ensure your business gets the most out
                      of workbrook.
                    </p>
                  </div>
                </div>
              </div>

              <div className="d-flex justify-content-center mt-4">
                <button
                  type="button"
                  className="btn btn-link"
                  onClick={() => setShowBusinessMessage(false)}
                  style={{ color: "#3A6ED4", fontWeight: "500" }}
                >
                  ← Back to Login
                </button>
              </div>
            </div>
          ) : (
            <div className="auth-form ml-md-4 my-5">
              <h4 className="text-center mt-4">Login To Your Account</h4>

              <CustomButton
                icon={WBlogo}
                alt="logo"
                backgroundColor="black"
                color="#fff"
                text="Switch to workbrook Business"
                additionalClass="mb-4"
                handleClick={() => switchToBusiness()}
              />
              <p className="demarcator text-center"> Login</p>

              {showsocial ? (
                <form onSubmit={handleSubmit}>
                  <CustomInput
                    onChange={handleChange}
                    type="text"
                    label="Email"
                    id="email"
                    value={state.email}
                    placeholder=""
                    autoComplete="email"
                  />

                  <CustomInput
                    onChange={handleChange}
                    type="password"
                    label="Password"
                    id="password"
                    placeholder=""
                    value={state.password}
                    icon={EyeIcon}
                    // autoComplete="current-password"
                  />

                  <div className="d-flex justify-content-between align-items-center mt-3 small-text">
                    <FormControlLabel
                      control={
                        <Checkbox
                          color="primary"
                          id="rememberMe"
                          onChange={handleChange}
                          checked={state.rememberMe}
                        />
                      }
                      label="Remember Me"
                    />
                    <Link to="/forgotPassword">Forgot Password?</Link>
                  </div>

                  {validationError && (
                    <p className="text-danger text-center mt-2 mb-0">
                      {validationError}
                    </p>
                  )}

                  <CustomButton
                    type="submit"
                    backgroundColor="#3A6ED4"
                    color="#fff"
                    text="Login"
                    loading={loading}
                    additionalClass="my-3"
                  />

                  <p className="demarcator text-center mt-4">
                    {" "}
                    Or use Social Logins
                  </p>

                  <div className="login-box">
                    <a
                      href="#"
                      className="social-button w-100 fw-bold"
                      id="google-connect"
                      onClick={(e) => {
                        e.preventDefault();
                        if (googleLoginClickHandler.current) {
                          googleLoginClickHandler.current();
                        } else if (sheetRef.current) {
                          sheetRef.current.click();
                        }
                      }}
                    >
                      {" "}
                      <span>Continue with Google</span>
                    </a>
                  </div>
                </form>
              ) : (
                <div className="login-box">
                  <a
                    href="#"
                    className="social-button fw-bold"
                    id="email-connect"
                    onClick={(e) => {
                      e.preventDefault();
                      setShowSocial(true);
                    }}
                  >
                    {" "}
                    <span>Login with email</span>
                  </a>

                  <a
                    href="#"
                    className="social-button fw-bold"
                    id="google-connect"
                    onClick={(e) => {
                      e.preventDefault();
                      if (googleLoginClickHandler.current) {
                        googleLoginClickHandler.current();
                      } else if (sheetRef.current) {
                        sheetRef.current.click();
                      }
                    }}
                  >
                    {" "}
                    <span>Connect with Google</span>
                  </a>
                </div>
              )}

              <div style={{ display: "none" }}>
                <div>
                  <GoogleLogin
                    clientId="302887164943-r6eh4rg4bglppaa3fu0bdlgkl4mfb1lb.apps.googleusercontent.com"
                    buttonText="Login"
                    render={(renderProps) => {
                      googleLoginClickHandler.current = renderProps.onClick;
                      return (
                        <button
                          onClick={renderProps.onClick}
                          ref={sheetRef}
                          disabled={renderProps.disabled}
                        >
                          This is my custom Google button
                        </button>
                      );
                    }}
                    onSuccess={responseGoogle}
                    onFailure={responseGoogle}
                  />
                </div>
              </div>
              <p
                className="pb-5 small-text text-center"
                style={{ fontSize: 15 }}
              >
                Don&apos;t have an account? <Link to="/signup">Sign Up</Link>{" "}
              </p>
            </div>
          )}
        </div>
      </AuthWrapper>
    </>
  );
};

export default Signin;
